import React from 'react';
import DatePicker from 'react-datepicker';

import './styles.scss';
import {
	connect,
} from 'react-redux';
import 'rc-datepicker/lib/style.css';
import Table from '../../../../components/table';
import { getItemDashboardTeam, ACTIONS, convertData, getItemDashboard, converDataDashboard, getDropdownDashboard } from './../../../../actions/dashboard';
import {
	dateInWeek, backAWeek, nextAWeek, backADay,
	nextADay, getExactDate
} from '../../../../common/services/timesServices';
import moment from 'moment';
import Loading from '../../../../components/loading';
import {
	getNoticesLatest,
	ACTIONS_NOTIFICATION
} from './../../../../actions/notification';

class Dashboard extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			h1: [],
			datePicker: new Date(),
			itemTb1: [],
			itemTb2: [],
			getYear: 0,
			dateArr: [],
			itemDropDown: [],
			showLoading: false,
			league1Item: [],
			league2Item: [],
			league3Item: []
		};
		this.onRedirect = this.onRedirect.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.props.getItemDashboard();
	}

	componentDidMount() {
		this.setState({ showLoading: true });
		let currenDate = moment(new Date()).format('YYYY/MM/DD');
		this.props.getItemDashboardTeam(currenDate);
		this.props.getDropdownDashboard();
		this.props.getNoticesLatest();
	}

	handleDate(text) {
		switch (text) {
			case 'back7days':
				this.setState({ showLoading: true, h1: ['チーム', ...backAWeek(7, this.state.h1)] }, () => {
					this.props.getItemDashboardTeam(`${this.state.h1[4]}/${this.state.getYear}`)
				});
				break;
			case 'yesterday':
				this.setState({ showLoading: true, h1: ['チーム', ...backADay(this.state.h1)] }, () => {
					this.props.getItemDashboardTeam(`${this.state.h1[4]}/${this.state.getYear}`)
				});
				break;
			case 'next7days':
				this.setState({ showLoading: true, h1: ['チーム', ...nextAWeek(7, this.state.h1)] }, () => {
					// console.log(`${this.state.h1[4]}/${this.state.getYear}`);
					this.props.getItemDashboardTeam(`${this.state.h1[4]}/${this.state.getYear}`)
				});
				break;
			case 'tomorrow':
				this.setState({ showLoading: true, h1: ['チーム', ...nextADay(this.state.h1)] }, () => {
					this.props.getItemDashboardTeam(`${this.state.h1[4]}/${this.state.getYear}`)
				});
				break;
			case 'today':
				this.setState({ showLoading: true, h1: ['チーム', ...dateInWeek()] }, () => {
					this.props.getItemDashboardTeam(`${this.state.h1[4]}/${this.state.getYear}`)
				});
				break;
			default:
				break;
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {

		if (nextProps) {
			if (nextProps.status === ACTIONS.GET_ITEM_DASHBOARDS_TEAM_SUCCESS) {
				this.setState({
					h1: ['チーム', ...nextProps.headerDate.map((value) => moment(value, 'MM/DD').format('M/D'))],
					dateArr: nextProps.headerDate,
					getYear: nextProps.getYear,
				}, () => {
					// const itemTeamDrop = [{
					// 	id: -1,
					// 	teamName: "全球団"
					// }]
					// nextProps.response.forEach(function (o) {
					// 	itemTeamDrop.push({
					// 		id: o.id,
					// 		teamName: o.teamName
					// 	})
					// })
					const d1 = (nextProps.response || []).filter(value => value.league_id === 1);
					const d2 = (nextProps.response || []).filter(value => value.league_id === 2);
					this.setState({
						itemTb1: convertData(d1, this.state.dateArr),
						itemTb2: convertData(d2, this.state.dateArr),
						showLoading: false
					});
				});
			} else if (nextProps.status === ACTIONS.GET_ITEM_DASHBOARDS_TEAM_ERROR) {
				this.setState({
					showLoading: false
				})
			}
			if (nextProps.statusDashboard === ACTIONS.GET_ITEM_DASHBOARDS_SUCCESS && nextProps.responseDashboard) {
				const items = nextProps.responseDashboard;
				this.setState({
					league1Item: converDataDashboard((items[0] || {}).data || []),
					league2Item: converDataDashboard((items[1] || {}).data || []),
					league3Item: converDataDashboard((items[2] || {}).data || []),
					showLoading: false
				});
			} else if (nextProps.statusDashboard === ACTIONS.GET_ITEM_DASHBOARDS_ERROR) {
				this.setState({
					showLoading: false
				})
			}
			if ((nextProps.statusDashboard === ACTIONS.GET_DROPDOWN_DASHBOARD_SUCCESS && nextProps.dataDropdown) || nextProps.statusDashboard === ACTIONS.GET_DROPDOWN_DASHBOARD_ERROR) {
				const itemTeamDrop = [{
					id: -1,
					teamName: "全球団"
				}]
				const mergeDataDropdown = nextProps.dataDropdown['central_league'] ? nextProps.dataDropdown['central_league'].concat(nextProps.dataDropdown['pacific_league']) : []
				mergeDataDropdown.forEach(function (o) {
					itemTeamDrop.push({
						id: o.id,
						teamName: o.team_name_s
					})
				})
				this.setState({
					itemDropDown: itemTeamDrop
				})
			} else {
				this.setState({
					showLoading: false
				})
			}

			if (nextProps.statusNotice === ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_SUCCESS) {
				let notice = nextProps.responseNotice;
				if (notice && notice.content) {
					this.setState({
						textNotification: notice.content.length > 50 ? notice.content.slice(0, 50) : notice.content
					})
				} else {
					this.setState({
						textNotification: ""
					})
				}

			}
		} else {
			this.setState({ showLoading: false });
		}
	}

	toDashboard(ev) {
		const team = this.state.itemDropDown.find(function (o) {
			return o.teamName === ev
		});
		if (team && team.id >= 0) {
			const { history } = this.props;
			history.push({
				pathname: '/dashboard-team',
				search: `?id=${team.id}`
			});
		}
	}

	chooseExactlyDate(ev) {
		this.setState({ showLoading: true, h1: ['チーム', ...getExactDate(ev)] }, () => {
			this.props.getItemDashboardTeam(ev.split('-').join('/'));
		});
	}

	onRedirect(value) {
		this.props.history.push('/team-report/' + value.team_id);
	}

	onGoToNotice() {
		this.props.history.push('/news');
	}

	render() {
		const { history } = this.props;
		return (
			<div className="wrap-dashboard">
				<h1 className="title-dashboard">ダッシュボード
					<span>
                        <i className="fa fa-question-circle"></i>
                        <div className='tooltips-dash'><p>直近の試合日程とチーム勝敗表が表示できます。</p></div>
                    </span>
				</h1>
				{this.state.textNotification ? <div className="notice" onClick={() => this.onGoToNotice()}	>
					<img alt="notice" className="img-notice" src="/img/ic_notice.svg" />
					<p className="text-white">{this.state.textNotification}</p>
				</div> : null}
				<div className="body-dashboard">
					<div className="head--tables justify-content-between">
						<div className="head--tables-left align-items-center">
							<span className={'title-span'}>日程表</span>
							{/* DATE EVENTS */}
							{
								this.props.listButton.map((value, key) => {
									return <button
										className={'date-button'}
										key={key.toString()}
										onClick={() => this.handleDate(value.event)} type="button">{value.name}</button>
								})
							}
							<DatePicker
								className={'dsa-datepicker'}
								dateFormat="yyyy/MM/dd"
								selected={this.state.datePicker}
								onChange={date => {
									this.setState({datePicker: date})
									this.chooseExactlyDate(moment(date).format('YYYY/MM/DD'));
								}} />
						</div>
						<div className="head--tables-right">
							{/* CHOOSE TEAM */}
							<select onChange={ev => this.toDashboard(ev.target.value)} className="form-control select-custom">
								{
									this.state.itemDropDown.map((item, index) =>
										<option key={index.toString()}>{item.teamName}</option>)
								}
							</select>
						</div>
					</div>

					<div className="body--tables">
						<div className="body--tables-top bg-white rounded">
							<div className="overflow-table">
								<Table
									showPagination={false} header={this.state.h1} showScrollX={true}// + val.it.id + "&teamId=" +
									showCheckbox={false} openLink={(val) => {
										history.push(val.url, {finish: val.finish})
									}}
									itemOfPage={this.state.itemTb1}
									titleTable={this.props.titleTable1}
								/>
							</div>
						</div>
						<div className="body--tables-middle bg-white rounded">
							<div className="overflow-table">
								<Table
									showPagination={false} header={this.state.h1} showScrollX={true}
									showCheckbox={false} openLink={(val) => {
										history.push(val.url, {finish: val.finish})
									}}
									itemOfPage={this.state.itemTb2}
									titleTable={this.props.titleTable2}
								/>
							</div>
						</div>

						{/* DASHBOARD ALL */}
						<div>
							<h2 className="title-win-lose">チーム勝敗表</h2>
							<div className="">
								<div className="col-6 p-0 wrap-win-lose">

									{/* LEAGUE 1 */}
									<div>
										<Table
											showPagination={false} header={this.props.leagueHeader}
											showCheckbox={false} itemOfPage={this.state.league1Item}
											titleTable={this.props.titleTable3}
											onRowClick={this.onRedirect}
										/>
									</div>

									{/* LEAGUE 2 */}
									<div>
										<Table
											showPagination={false} header={this.props.leagueHeader}
											showCheckbox={false} itemOfPage={this.state.league2Item}
											titleTable={this.props.titleTable4}
											onRowClick={this.onRedirect}
										/>
									</div>
									{/* LEAGUE ALL */}
									<div>
										<Table
											showPagination={false} header={this.props.leagueHeader}
											showCheckbox={false} itemOfPage={this.state.league3Item}
											titleTable={this.props.titleTable5}
											onRowClick={this.onRedirect}
										/>
									</div>
								</div>


							</div>
						</div>
					</div>
				</div>
				<Loading show={this.state.showLoading} />
			</div >
		);
	}
}

const mapStateToProps = ({ dashboard, notification }) => {
	return {
		status: dashboard.status,
		response: dashboard.response,
		headerDate: dashboard.headerDate,
		statusDashboard: dashboard.statusDashboard,
		responseDashboard: dashboard.responseDashboard,
		leagueHeader: dashboard.leagueHeader,
		getYear: dashboard.year,
		titleTable1: dashboard.titleTable1,
		titleTable2: dashboard.titleTable2,
		titleTable3: dashboard.titleTable3,
		titleTable4: dashboard.titleTable4,
		titleTable5: dashboard.titleTable5,
		listButton: dashboard.listButton,
		dataDropdown: dashboard.dataDropdown,
		responseNotice: notification.responseNotice,
		statusNotice: notification.statusNotice
	}
};

const mapDispatchToProps = (dispatch) => ({
	getItemDashboardTeam: (date) => {
		dispatch(getItemDashboardTeam(date));
	},
	getItemDashboard: () => {
		dispatch(getItemDashboard());
	},
	getDropdownDashboard: () => {
		dispatch(getDropdownDashboard());
	},
	getNoticesLatest: () => {
		dispatch(getNoticesLatest())
	}
});

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Dashboard);
